import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=303fc035"
import script from "./UiSelect.vue?vue&type=script&lang=js"
export * from "./UiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports